export const copyToClipBoard = async (text: string) => {
  try {
    if (!navigator?.clipboard?.writeText) {
      throw new Error('Not support')
    }
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    //
  }
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    return true
  } catch (error) {
    console.error('Failed to copy:', error)
  }
  return false
}

export const pasteFromClipBoard = async () => {
  return (await navigator.clipboard?.readText()) ?? ''
}

export const isUrlImage = (string: string): boolean => {
  try {
    const urlPattern = /^(https?:\/\/|\/\/|\/)?[^\s/$.?#].[^\s]*\.(svg|png|jpg|jpeg|gif|webp)$/i
    return urlPattern.test(string) || string.startsWith('data:image/') // base64
  } catch {
    return false
  }
}

export const delay = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
